<template>
  <div class="icon icon-scale-rotate" v-html="IconScaleRotate"></div>
</template>

<script>
import IconScaleRotate from './icon-scale-rotate.svg'
export default {
  data () {
    return {
      IconScaleRotate: IconScaleRotate
    }
  }
}
</script>
<style lang='scss'>
.icon-scale-rotate{
  svg{
    .sr-a,.sr-b,.sr-d{
      fill: none;
    }
    .sr-a,.sr-b{
      stroke:#000;
      stroke-width: 1.5px;
    }
    .sr-b{
      stroke-linecap: round;
    }
    .sr-c{
      stroke: none;
    }
  }
  &.selected{
    svg{
      .sr-a,.sr-b{
        stroke: #0000FF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/svgs/IconScaleRotate.vue